import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";

import { BsFacebook, BsInstagram, BsTwitter } from "react-icons/bs"; 

const Footer = () => {
  return (
  <footer className="px-3 navber pt-10 mt-10 border-t bg-gray-1200 text-white relative sm:px-6 lg:px-4">

      {/* Background Effects */}
      <div className="absolute left-20 top-0 size-28 bg-white rounded-full blur-2xl opacity-30 -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute right-20 top-0 size-28 bg-white rounded-full blur-2xl opacity-30 -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 left-10 w-0 h-0 border-l-[40px] border-r-[40px] border-b-[70px] border-l-transparent border-r-transparent border-b-white opacity-10"></div>
      <div className="absolute bottom-0 right-10 w-0 h-0 border-l-[40px] border-r-[40px] border-b-[70px] border-l-transparent border-r-transparent border-b-white opacity-10"></div>

      {/* Footer Content */}
      <div className="max-w-6xl mx-auto grid gap-10 mb-10 sm:grid-cols-2 lg:grid-cols-6">
        {/* About Section */}
        <div className="sm:col-span-2">
          <Link to="/" aria-label="Go home" title="Enginuity Systems" className="inline-flex items-center">
            <div className="w-full">
              <img width="180" className="rounded-lg" src={Logo} alt="logo" />
            </div>
          </Link>
          <div className="mt-4 text-sm text-gray-300 max-w-sm">
            <p className="text-xl font-bold py-2 uppercase">Enginuity System</p>
            <p>
              Enginuity Systems blends software development with skills-based education,
              empowering learners from diverse backgrounds to become job-ready backend engineers.
            </p>
            <p className="mt-3">
              We deliver scalable, enterprise-grade software to clients while training
              students in DevOps, CI/CD, and cloud-native development using real-world projects.
            </p>
          </div>
        </div>

        {/* Link Sections */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-5 sm:col-span-4 mt-6 sm:mt-0">
          {[
            {
              title: "Programs",
              items: [
                { title: "Backend Engineering", link: "#" },
                { title: "Capstone Projects", link: "#" },
                { title: "Cloud Training", link: "#" },
                { title: "SDLC Mastery", link: "#" },
              ],
            },
            {
              title: "Services",
              items: [
                { title: "Software Development", link: "#" },
                { title: "DevOps", link: "#" },
                { title: "Cloud Solutions", link: "#" },
                { title: "System Architecture", link: "#" },
              ],
            },
            {
              title: "Resources",
              items: [
                { title: "Documentation", link: "#" },
                { title: "GitHub", link: "#" },
                { title: "Blogs", link: "#" },
                { title: "Case Studies", link: "#" },
              ],
            },
            {
              title: "Company",
              items: [
                { title: "About Us", link: "/" },
                { title: "Careers", link: "#" },
                { title: "Contact", link: "/contact" },
                { title: "Privacy Policy", link: "#" },
              ],
            },
          ].map((section, idx) => (
            <div key={idx}>
              <p className="font-bold text-white mb-2">{section.title}</p>
              <ul className="space-y-2 text-gray-400">
                {section.items.map((item, i) => (
                  <li key={i}>
                    <Link to={item.link} className="hover:text-white text-sm transition-colors duration-200">
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between border-t border-gray-800 pt-5 pb-10 text-sm text-gray-400 px-4">
        {/* Social Icons */}
        <div className="flex items-center space-x-4 mb-4 sm:mb-0">
          {[
            { name: "Twitter", link: "#", icon: <BsTwitter size={20} /> },
            { name: "Instagram", link: "#", icon: <BsInstagram size={20} /> },
            { name: "Facebook", link: "https://shorturl.at/KfNvo", icon: <BsFacebook size={20} /> },
          ].map(
            (social, index) =>
              social.icon &&
              social.link && (
                <Link
                  key={index}
                  to={social.link}
                  aria-label={social.name}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors duration-300"
                >
                  {social.icon}
                </Link>
              )
          )}
        </div>

        {/* Copyright */}
        <p className="text-center sm:text-left">© 2025 Enginuity Systems. All rights reserved.</p>
      </div>
  </footer>
  );
};

export default Footer;
